import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

// Matching emojis for each step
const stepEmojis = [
  "🪑", "🌬️", "💆", "🙈", "😮‍💨", "💖", "👀"
];

// Gentle pulse animation
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255,209,102,0.18); }
  70% { box-shadow: 0 0 0 14px rgba(255,209,102,0.06); }
  100% { box-shadow: 0 0 0 0 rgba(255,209,102,0.0); }
`;

const EmojiBubble = styled.div`
  width: 78px;
  height: 78px;
  margin: 0 auto 20px auto;
  border-radius: 50%;
  background: #fffbe6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.4rem;
  animation: ${pulse} 2s infinite;
  box-shadow: 0 2px 10px rgba(255,209,102,0.08);
  transition: background 0.4s;
`;

const CuteButton = styled.button`
  padding: 12px 32px;
  border-radius: 20px;
  background: #FFD166;
  color: #222;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 1.08em;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(255,209,102,0.09);
  transition: background 0.2s;
  &:hover { background: #ffe29a; }
`;

const navBtnStyle = {
  background: "#FFD166",
  border: "none",
  borderRadius: 16,
  padding: "8px 20px",
  fontWeight: 600,
  cursor: "pointer",
  marginRight: 10,
  fontSize: "1em"
};

const steps = [
  "Sit comfortably and let your hands rest in your lap.",
  "Take a slow, deep breath in through your nose... and out through your mouth.",
  "Roll your shoulders gently back and down.",
  "Close your eyes. Notice any tension in your body and let it go.",
  "Take 3 slow, deep breaths. In... and out.",
  "Think of one thing you’re grateful for. Hold that thought for a moment.",
  "Gently open your eyes. Notice how you feel."
];

export default function QuickDestressTool() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  // Step-wise navigation
  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(s => s + 1);
    } else {
      navigate("/"); // Go back to dashboard on Done
    }
  };

  const handleBack = () => {
    if (step > 0) {
      setStep(s => s - 1);
    } else {
      // If at first step, go back in browser history or home
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate("/");
      }
    }
  };

  const goHome = () => navigate("/");

  return (
    <div style={{
      maxWidth: 500,
      margin: "40px auto",
      background: "#fffbe6",
      borderRadius: 24,
      boxShadow: "0 2px 12px rgba(255,209,102,0.10)",
      padding: 32,
      textAlign: "center",
      border: "2px solid #ffe29a"
    }}>
      {/* Navigation Buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 10 }}>
        <button
          onClick={handleBack}
          style={{ ...navBtnStyle, opacity: step === 0 ? 1 : 1 }}
        >
          ← Back
        </button>
        <button onClick={goHome} style={navBtnStyle}>🏠 Home</button>
      </div>
      <h2 style={{ marginBottom: 8 }}>Quick De-Stress</h2>
      <p style={{ color: "#b48b1e" }}>
        Use this 3-minute routine to reset your mind and body.
      </p>
      <EmojiBubble>
        {stepEmojis[step]}
      </EmojiBubble>
      <div style={{
        minHeight: 80,
        fontSize: 19,
        margin: "32px 0",
        color: "#444",
        transition: "color 0.2s"
      }}>
        {steps[step]}
      </div>
      <CuteButton onClick={handleNext}>
        {step === steps.length - 1 ? "Done" : "Next"}
      </CuteButton>
    </div>
  );
}
